import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import { Form, Input, Button, Icon } from 'antd';

export default class FinalizeForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values.password);
            }
        });
    }
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading } = this.props;

        return (
            <Form onSubmit={this.handleSubmit} className="login-form" style={styles.form}>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [
                            { 
                                required: true, message: 'Lösenord saknas!'
                            },
                            {
                                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, message: 'Minst en stor bokstav, en liten bokstav samt en siffra',
                            },
                            {
                                min: 6, message: 'Minst sex tecken'
                            }
                        ],
                    })(
                        <Input prefix={<Icon type="lock" style={styles.input} />} type="password" placeholder="Lösenord" />
                    )}
                </Form.Item>

                <Form.Item style={{ marginTop: '20px' }}>
                    <Button type="primary" block htmlType="submit" loading={loading}>
                        Slutför registrering
                    </Button>
                    <span>Har du redan ett konto: </span><NavLink to="/auth/login">Logga in</NavLink>
                </Form.Item>
            </Form>
        );
    };
}

const styles = {
    input: { color: 'rgba(0,0,0,.25)' }
};


// WEBPACK FOOTER //
// ./src/screens/auth/components/register/FinalizeForm.js